export const fr = {
  // Common
  "common": {
    "welcome": "Bienvenue sur",
    "search": "Rechercher",
    "loading": "Chargement...",
    "error": "Une erreur est survenue",
    "save": "Enregistrer",
    "cancel": "Annuler",
    "delete": "Supprimer",
    "edit": "Modifier",
    "view": "Voir",
    "viewAll": "Voir tout",
    "add": "Ajouter",
    "remove": "Retirer",
    "back": "Retour",
    "next": "Suivant",
    "previous": "Précédent",
    "submit": "Soumettre",
    "confirm": "Confirmer",
    "success": "Succès",
    "warning": "Avertissement",
    "info": "Information",
    "required": "Obligatoire",
    "optional": "Optionnel",
    "all": "Tous",
    "active": "Actif",
    "inactive": "Inactif",
    "pending": "En attente",
    "completed": "Terminé",
    "cancelled": "Annulé",
    "rejected": "Refusé",
    "approved": "Approuvé",
    "yes": "Oui",
    "no": "Non",
    "or": "ou",
    "and": "et",
    "saving": "Enregistrement...",
    "updating": "Mise à jour...",
    "deleting": "Suppression...",
    "processing": "Traitement...",
    "pleaseWait": "Veuillez patienter...",
    "notFound": "Non trouvé",
    "noResults": "Aucun résultat trouvé",
    "noData": "Aucune donnée disponible",
    "close": "Fermer",
    "apply": "Appliquer",
    "reset": "Réinitialiser",
    "clearAll": "Tout effacer",
    "clearFilters": "Effacer les filtres",
    "retry": "Réessayer"
  },
  
  // Navigation
  "nav": {
    "home": "Accueil",
    "products": "Produits",
    "videos": "Vidéos",
    "cart": "Panier",
    "wishlist": "Favoris",
    "profile": "Profil",
    "settings": "Paramètres",
    "becomeSeller": "Devenir Vendeur",
    "becomeDelivery": "Devenir Livreur",
    "sellerDashboard": "Tableau de Bord Vendeur",
    "deliveryDashboard": "Tableau de Bord Livreur",
    "management": "Gestion",
    "competitions": "Compétitions",
    "login": "Connexion",
    "register": "Inscription",
    "logout": "Déconnexion",
    "admin": "Administration",
    "orders": "Commandes",
    "sellers": "Vendeurs",
    "deliveryPartners": "Livreurs",
    "deliveries": "Livraisons",
    "users": "Utilisateurs",
    "payments": "Paiements",
    "paymentHistory": "Historique des Paiements"
  },
  
  // Home page
  "home": {
    "hero": {
      "title": "Bienvenue sur AEM Marketplace",
      "subtitle": "Votre destination unique pour acheter, vendre et livrer des produits en toute simplicité. Rejoignez notre communauté de vendeurs et acheteurs dès aujourd'hui !",
      "browseProducts": "Parcourir les Produits",
      "becomeSeller": "Devenir Vendeur"
    },
    "categories": {
      "title": "Catégories Populaires",
      "subtitle": "Explorez notre large gamme de produits"
    },
    "featuredProducts": {
      "title": "Produits en Vedette"
    },
    "testimonials": {
      "title": "Ce que disent nos utilisateurs",
      "subtitle": "Découvrez les expériences de notre communauté grandissante",
      "buyer": "Acheteur",
      "seller": "Vendeur",
      "delivery": "Livreur"
    },
    "stats": {
      "title": "AEM Marketplace en chiffres",
      "subtitle": "Rejoignez notre communauté en pleine croissance",
      "users": "Utilisateurs",
      "products": "Produits",
      "deliveries": "Livraisons",
      "satisfaction": "Satisfaction"
    },
    "howItWorks": {
      "title": "Comment ça marche",
      "subtitle": "Achetez et vendez en toute simplicité sur notre plateforme",
      "cta": "Commencer maintenant",
      "step1": {
        "title": "Parcourez les produits",
        "description": "Explorez notre vaste catalogue de produits de qualité"
      },
      "step2": {
        "title": "Passez commande",
        "description": "Choisissez vos articles et effectuez votre paiement en toute sécurité"
      },
      "step3": {
        "title": "Livraison rapide",
        "description": "Nos partenaires de livraison s'occupent de tout"
      },
      "step4": {
        "title": "Profitez de vos achats",
        "description": "Recevez vos produits et partagez votre expérience"
      }
    }
  },
  
  // Products
  "products": {
    "title": "Tous les Produits",
    "subtitle": "Parcourez notre collection de produits uniques",
    "filters": "Filtres",
    "activeFilters": "Filtres actifs",
    "noProductsFound": "Aucun produit ne correspond à vos critères de recherche",
    "sort": {
      "title": "Trier par",
      "newest": "Plus récents",
      "priceAsc": "Prix: Croissant",
      "priceDesc": "Prix: Décroissant",
      "popular": "Plus populaires"
    },
    "addToCart": "Ajouter au panier",
    "addedToCart": "Ajouté au panier",
    "outOfStock": "Rupture de stock",
    "price": "Prix",
    "minPrice": "Prix minimum",
    "category": "Catégorie",
    "seller": "Vendeur",
    "description": "Description",
    "deliveryOptions": "Options de Livraison",
    "standard": "Standard",
    "express": "Express",
    "pickup": "Retrait",
    "pickupAddress": "Adresse de retrait",
    "estimatedDelivery": "Délai de livraison estimé",
    "days": "jours",
    "reviews": "Avis",
    "writeReview": "Donner votre avis",
    "noReviews": "Aucun avis pour le moment",
    "rating": "Note",
    "comment": "Commentaire",
    "submitReview": "Publier l'avis",
    "productDetails": "Détails du produit"
  },
  
  // Cart
  "cart": {
    "title": "Votre Panier",
    "empty": "Votre panier est vide",
    "addProducts": "Ajoutez des produits pour commencer vos achats",
    "browseProducts": "Parcourir les produits",
    "summary": "Résumé de la commande",
    "subtotal": "Sous-total",
    "shipping": "Frais de livraison",
    "tax": "Taxes",
    "total": "Total",
    "checkout": "Passer à la caisse",
    "continueShopping": "Continuer les achats",
    "remove": "Retirer",
    "quantity": "Quantité",
    "delivery": "Livraison",
    "payment": "Paiement",
    "deliveryInfo": "Informations de livraison",
    "address": "Adresse",
    "city": "Ville",
    "zipCode": "Code postal",
    "phone": "Téléphone",
    "continueToDelivery": "Continuer vers la livraison",
    "continueToPayment": "Continuer vers le paiement",
    "finalizePayment": "Finaliser le paiement",
    "paymentSuccess": "Paiement réussi !",
    "orderConfirmed": "Votre commande a été confirmée et sera traitée rapidement. Vous recevrez un email de confirmation avec les détails de votre commande.",
    "redirecting": "Redirection vers la page des produits..."
  },
  
  // Auth
  "auth": {
    "login": {
      "title": "Bienvenue sur AEM",
      "subtitle": "Connectez-vous à votre compte",
      "noAccount": "Pas encore de compte ?",
      "createAccount": "Créer un compte",
      "email": "Adresse email",
      "password": "Mot de passe",
      "forgotPassword": "Mot de passe oublié ?",
      "loginButton": "Se connecter",
      "loggingIn": "Connexion..."
    },
    "register": {
      "title": "Créer votre compte",
      "subtitle": "Vous avez déjà un compte ?",
      "signIn": "Se connecter",
      "email": "Adresse email",
      "password": "Mot de passe",
      "role": "Je veux",
      "buy": "Acheter",
      "sell": "Vendre",
      "deliver": "Livrer",
      "createButton": "Créer un compte",
      "creating": "Création du compte..."
    }
  },
  
  // Settings
  "settings": {
    "title": "Paramètres",
    "subtitle": "Gérez vos préférences et informations de compte",
    "tabs": {
      "profile": "Profil",
      "security": "Sécurité",
      "notifications": "Notifications",
      "language": "Langue et Région"
    },
    "profile": {
      "fullName": "Nom Complet",
      "email": "Email",
      "emailCannotBeChanged": "L'email ne peut pas être modifié",
      "phoneNumber": "Numéro de Téléphone",
      "region": "Région",
      "regionPlaceholder": "Votre région (ex: Port-au-Prince)",
      "saveChanges": "Enregistrer les Modifications",
      "saving": "Enregistrement..."
    },
    "security": {
      "currentPassword": "Mot de Passe Actuel",
      "newPassword": "Nouveau Mot de Passe",
      "confirmPassword": "Confirmer le Mot de Passe",
      "passwordRequirements": "Le mot de passe doit contenir au moins 6 caractères",
      "securityTips": "Conseils de sécurité",
      "tip1": "Utilisez un mot de passe unique pour chaque site",
      "tip2": "Incluez des lettres majuscules, minuscules, des chiffres et des symboles",
      "tip3": "Évitez d'utiliser des informations personnelles facilement devinables",
      "updatePassword": "Mettre à jour le Mot de Passe",
      "updating": "Mise à jour..."
    },
    "notifications": {
      "emailNotifications": "Notifications par email",
      "allNotifications": "Toutes les notifications",
      "orderUpdates": "Mises à jour des commandes",
      "statusAndDelivery": "Statut et livraison",
      "marketingEmails": "Emails marketing",
      "promotionsAndOffers": "Promotions et offres",
      "newMessages": "Nouveaux messages",
      "chatsAndNegotiations": "Chats et négociations",
      "aboutNotifications": "À propos des Notifications",
      "notificationsHelp": "Les notifications vous aident à rester informé des activités importantes sur votre compte. Vous pouvez les personnaliser selon vos préférences.",
      "savePreferences": "Enregistrer les Préférences"
    },
    "language": {
      "language": "Langue",
      "region": "Région",
      "regionPlaceholder": "Votre région (ex: Port-au-Prince)",
      "regionalPreferences": "Préférences régionales",
      "regionalPreferencesHelp": "Ces paramètres affectent la façon dont les dates, les prix et autres éléments régionaux sont affichés.",
      "savePreferences": "Enregistrer les Préférences"
    },
    "deleteAccount": {
      "title": "Supprimer le compte",
      "warning": "Une fois que vous supprimez votre compte, toutes vos données seront définitivement effacées. Cette action ne peut pas être annulée.",
      "deleteButton": "Supprimer le compte",
      "disabledMessage": "La suppression de compte est désactivée dans cette démo"
    }
  },
  
  // Seller
  "seller": {
    "dashboard": {
      "title": "Tableau de Bord Vendeur",
      "products": "Produits",
      "orders": "Commandes",
      "delivery": "Livraisons",
      "videos": "Vidéos",
      "revenue": "Revenus",
      "payments": "Paiements",
      "settings": "Paramètres",
      "addProduct": "Ajouter un Produit",
      "searchProduct": "Rechercher un produit...",
      "noProducts": "Aucun produit pour le moment",
      "productLimitReached": "Limite de produits atteinte",
      "views": "vues",
      "sales": "ventes",
      "active": "actifs"
    }
  },
  
  // Videos
  "videos": {
    "title": "Vidéos Produits",
    "subtitle": "Regardez des démonstrations et avis de produits de notre communauté",
    "myVideos": "Mes Vidéos",
    "allVideos": "Toutes les Vidéos",
    "uploadVideo": "Télécharger une Vidéo",
    "noVideos": "Aucune vidéo pour le moment",
    "uploadYourFirst": "Téléchargez votre première vidéo",
    "recent": "Récentes",
    "popular": "Populaires",
    "views": "vues",
    "likes": "j'aime",
    "comments": "commentaires",
    "addComment": "Ajouter un commentaire...",
    "loginToComment": "Connectez-vous pour commenter",
    "noComments": "Aucun commentaire pour le moment",
    "relatedProduct": "Produit associé",
    "viewProduct": "Voir le produit",
    "statistics": "Statistiques",
    "publishedOn": "Publié le",
    "deleteVideo": "Supprimer la vidéo",
    "deleteConfirmation": "Êtes-vous sûr de vouloir supprimer cette vidéo ? Cette action ne peut pas être annulée.",
    "videoDeleted": "Vidéo supprimée avec succès"
  }
};